import { createContext, useContext } from 'react'
import { Execute } from '../lib/types'

const RecaptchaContext = createContext<Execute | undefined>(undefined)

const RecaptchaContextProvider = RecaptchaContext.Provider

const useRecaptcha = (): Execute => {
  const context = useContext(RecaptchaContext)
  if (context === undefined) {
    throw new Error('useRecaptcha must be used within a RecaptchaContextProvider')
  }
  return context
}

export { RecaptchaContextProvider, useRecaptcha }
